import React, { CSSProperties } from 'react';
import { CursorProps } from 'react-arborist';

const placeholderStyle = {
  display: 'flex',
  alignItems: 'center',
  zIndex: 1,
};

const lineStyle = {
  flex: 1,
  height: '1.5px',
  background: 'var(--color-fletchers-green-500)',
  borderRadius: '1px',
};

export const BundleSectionsTreeCursor = React.memo(function DefaultCursor({ top, left, indent }: CursorProps) {
  // Above the first row, shift the line down 1px so it isn't clipped.
  const isTopBoundary = top === 0;
  const style: CSSProperties = {
    position: 'absolute',
    pointerEvents: 'none',
    top: isTopBoundary ? '1px' : top - 1 + 'px',
    left: left + 'px',
    right: indent + 'px',
  };
  return (
    <div style={{ ...placeholderStyle, ...style }}>
      <div style={{ ...lineStyle }}></div>
    </div>
  );
});
